/* tslint:disable */
/* eslint-disable */
/**
 * Local Map - Local Map Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.3
 * Contact: local-map@daangn.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../runtime';
import type { V1BusinessPost } from './V1BusinessPost';
import {
    V1BusinessPostFromJSON,
    V1BusinessPostFromJSONTyped,
    V1BusinessPostToJSON,
} from './V1BusinessPost';

/**
 * 
 * @export
 * @interface V1PublicInstitutionBusinessPostSection
 */
export interface V1PublicInstitutionBusinessPostSection {
    /**
     * 
     * @type {Array<V1BusinessPost>}
     * @memberof V1PublicInstitutionBusinessPostSection
     */
    businessPosts: Array<V1BusinessPost>;
    /**
     * 
     * @type {string}
     * @memberof V1PublicInstitutionBusinessPostSection
     */
    viewMoreTargetUri: string;
    /**
     * 
     * @type {string}
     * @memberof V1PublicInstitutionBusinessPostSection
     */
    region3Name: string;
    /**
     * 
     * @type {string}
     * @memberof V1PublicInstitutionBusinessPostSection
     */
    region3Id: string;
}

/**
 * Check if a given object implements the V1PublicInstitutionBusinessPostSection interface.
 */
export function instanceOfV1PublicInstitutionBusinessPostSection(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "businessPosts" in value;
    isInstance = isInstance && "viewMoreTargetUri" in value;
    isInstance = isInstance && "region3Name" in value;
    isInstance = isInstance && "region3Id" in value;

    return isInstance;
}

export function V1PublicInstitutionBusinessPostSectionFromJSON(json: any): V1PublicInstitutionBusinessPostSection {
    return V1PublicInstitutionBusinessPostSectionFromJSONTyped(json, false);
}

export function V1PublicInstitutionBusinessPostSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1PublicInstitutionBusinessPostSection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'businessPosts': ((json['business_posts'] as Array<any>).map(V1BusinessPostFromJSON)),
        'viewMoreTargetUri': json['view_more_target_uri'],
        'region3Name': json['region3_name'],
        'region3Id': json['region3_id'],
    };
}

export function V1PublicInstitutionBusinessPostSectionToJSON(value?: V1PublicInstitutionBusinessPostSection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'business_posts': ((value.businessPosts as Array<any>).map(V1BusinessPostToJSON)),
        'view_more_target_uri': value.viewMoreTargetUri,
        'region3_name': value.region3Name,
        'region3_id': value.region3Id,
    };
}

